import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Stack,
	Typography,
} from '@mui/material';
import React, { Dispatch, SetStateAction, useContext } from 'react';
import { DeckContext } from '../../context/DeckContext';
import { DeckContext as DeckContextV3 } from '../../context/DeckContextV3';
import { Block } from 'src/types/shared/blocksV3';
import useIsBetaCanvasEnabled from 'src/hooks/useBetaCanvas';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';

type ModalProps = {
	open: boolean;
	setOpen: Dispatch<SetStateAction<boolean>>;
	block: Block;
};

const DropbeamNotNeededModal: React.FC<ModalProps> = ({
	open,
	setOpen,
	block,
}) => {
	const isBetaEnabled = useIsBetaCanvasEnabled();

	const { state, dispatch } = isBetaEnabled
		? useContext(DeckContextV3)
		: useContext(DeckContext);

	return (
		<Dialog
			open={open}
			onClose={(e) => {
				e.preventDefault();
			}}
		>
			<DialogTitle>
				<Typography variant="h2" fontWeight="bold">
					<InfoOutlineIcon /> Dropbeam is no longer required for this build
				</Typography>
			</DialogTitle>

			<DialogContent>
				<Stack>
					<Typography
						color="black"
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'start',
							fontSize: '14px',
						}}
					>
						Based on the selected joist span and structural materials,
						additional support is not needed.
					</Typography>
				</Stack>
			</DialogContent>

			<DialogActions
				sx={{
					borderTop: '1px solid #8484854D',
				}}
			>
				<>
					<Button
						onClick={() => {
							setOpen(false);
						}}
						variant="contained"
						color="#484C52"
						sx={{
							fontWeight: 'bold',
							backgroundColor: 'transparent',
							border: '1px solid #8484854D',
						}}
					>
						Keep Dropbeam(s)
					</Button>

					<Button
						onClick={() => {
							dispatch({
								type: 'UPDATE_BLOCK',
								payload: {
									...block,
									dropbeam: {
										isIncluded: false,
										numberOfBoards: 0,
										quantity: 0,
									},
								},
							});

							if (state.displayedBlockModal?.id == block.id) {
								dispatch({
									type: 'OPEN_BLOCK_MODAL',
									payload: {
										...block,
										dropbeam: {
											isIncluded: false,
											numberOfBoards: 0,
											quantity: 0,
										},
									},
								});
							}

							setOpen(false);
						}}
						variant="contained"
						color="primary"
						sx={{ fontWeight: 'bold' }}
					>
						Remove Dropbeam(s)
					</Button>
				</>
			</DialogActions>
		</Dialog>
	);
};

export default DropbeamNotNeededModal;
